<template>
    <div class="row h-100">
        <div class="col-12 d-none d-md-block col-md-5">
            <div class="left__auth_block">
                <a class="header__logo" :href="homelink">
                    <img src="/img/logo_white.png" alt="">
                </a>
                <h2 class="mb-4">{{ get_translation_constant('text_has_account') }}</h2>
                <a class="btn btn__medium btn__black mb-4"
                   :href="loginlink">{{ get_translation_constant('text_entry_account') }}</a>
                <p>{{ get_translation_constant('text_to_place_order') }}</p>
            </div>
        </div>
        <div class="col-12 col-md-6 offset-md-1 col-lg-5 offset-lg-2">
            <div class="tab-pane " role="tabpanel">
                    <h2>{{ get_translation_constant('text_create_account') }}</h2>
                    <form @submit.prevent="sendEmailToVerifyLink()">
                        <div class="form__col " :class="hasError('email')">
                            <label for="email">{{ get_translation_constant('text_email') }}<sup>*</sup></label>
                            <input v-model="form.email" class="form__control" id="email" name="email" type="email"
                                   :placeholder="get_translation_constant('text_entry_email')">
                            <div class="form__error" v-if="hasErrorMessage('email')">
                                {{ hasErrorMessage('email') }}
                            </div>
                        </div>
                        <div class="form__col" :class="hasError('accept_terms')">
                            <div class="checkbox__custom">
                                <input v-model="form.accept_terms" id="application_rules" name="application_rules"
                                       type="checkbox">
                                <label for="application_rules">{{ get_translation_constant('text_agree_with') }} <a
                                    :href="termslink" target="_blank">{{
                                    get_translation_constant('text_condition_services')
                                    }}</a> {{ get_translation_constant('text_and') }} <a :href="personalinfolink" target="_blank">{{
                                    get_translation_constant('text_processing_personal_information')
                                    }}</a></label>
                            </div>
                            <div class="form__error" v-if="hasErrorMessage('accept_terms')">
                                {{ hasErrorMessage('accept_terms') }}
                            </div>
                        </div>
                        <div class="form__col" :class="hasError('server_error')">
                            <div class="form__error" v-if="hasErrorMessage('server_error')">
                                {{ hasErrorMessage('server_error') }}
                            </div>
                        </div>

                        <div class="form__col" >
                            <div v-if="success">
                                {{ success }}
                            </div>
                        </div>

                        <div class="form__col form__col_last">
                            <button @click.prevent="sendEmailToVerifyLink"
                                    class="btn btn__medium btn__block btn__green signup_next_step" id="step_2_show"
                                    data-toggle="tab" href="#step_2" role="tab" aria-controls="home"
                                    aria-selected="true">{{ get_translation_constant('text_create_account') }}
                            </button>
                        </div>
                    </form>
           </div>
        </div>
        <div class="col-12 d-md-none col-md-5 mt-5">
            <h5>{{ get_translation_constant('text_has_account') }}</h5>
            <p><a :href="loginlink">{{ get_translation_constant('text_entry_account') }}</a>, {{
                get_translation_constant('text_to_place_order') }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Register",
    props: {
        translations: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        loginlink: {
            type: [String]
        },
        redirect: {
            type: [String]
        },
        emailregistrationlink: {
            type: [String]
        },
        homelink: {
            type: [String]
        },
        nodeid : {
            type: [String, Boolean]
        },
        termslink : {
            type: [String, Boolean]
        },
        personalinfolink : {
            type: [String, Boolean]
        }

    },
    data() {
        return {
            errors: [],
            form: {
                locale: '',
                email: '',
                accept_terms: false,
            },
            form_user: {
                locale: '',
                first_name: '',
                last_name: '',
                first_name_latin: '',
                last_name_latin: '',

                gender_id: '',
                address: '',
                token: null
            },
            accept_terms: false,
            active_step: true,
            timer: null,
            success: false
        }
    },
    methods: {
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },


        sendEmailToVerifyLink() {
            let data = {
                locale: this.form.locale,
                email: this.form.email,
                accept_terms: this.form.accept_terms,
            }

            axios.post(this.emailregistrationlink, data).then(response => {
                if (response.status === 200) {
                    this.success = response.data.message;
                    this.errors = [];
                }
            }).catch(error => {
                if (error.response.status === 400) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                }
                if (error.response.status === 500) {
                    this.errors ={server_error: [error.response.data.message]};
                }
            });
        },
        hasError(error) {
            if (this.errors[error])
                return 'has__error';
        },

        hasErrorMessage(error) {
            if (this.errors[error])
                return this.errors[error][0];

        },
    },
    computed: {},
    mounted() {
        this.form.locale = this.lng;
        this.form_user.locale = this.lng;
    }
}
</script>

<style scoped>

</style>
